import React from 'react';
import PropTypes from 'prop-types';
import accounting from 'accounting';
import { Input as SemanticInput } from 'semantic-ui-react';

const ProjectSummary = ({ projectResume }) => (
  <div className="payment-card__content-card">
    <div className="payment-card__header">
      <h2>ITEMS</h2>
    </div>
    <div className="payment-card__items-content">
      <div className="payment-card__items-content-list">
        <ul>
          <li>
            <span className="payment-card__items-content-list-item">
              Project Category
            </span>
            <span className="payment-card__items-content-list-label">
              {projectResume.type}
            </span>
          </li>
          <li>
            <span className="payment-card__items-content-list-item">
              Duration
            </span>
            <span className="payment-card__items-content-list-label">
              {projectResume.duration}
            </span>
          </li>
          <li>
            <span className="payment-card__items-content-list-item">
              Video Quantity
            </span>
            <span className="payment-card__items-content-list-label">
              {projectResume.series}
            </span>
          </li>
          <li>
            <span className="payment-card__items-content-list-item">
              Aspect Ratio
            </span>
            <span className="payment-card__items-content-list-label">
              {projectResume.format}
            </span>
          </li>
          <li>
            <span className="payment-card__items-content-list-item">
              Production Type
            </span>
            <span className="payment-card__items-content-list-label">
              {projectResume.basic_requirements}
            </span>
          </li>
        </ul>
        <div className="payment-card__items-content-subtotal">
          <div className="payment-card__items-content-subtotal-label">
            Total:
          </div>
          <div className="payment-card__items-content-subtotal-value">
            ${accounting.format(projectResume.finalPrice)}
          </div>
        </div>
      </div>
      <div className="payment-card__items-content-promocode">
        <div className="payment-card__items-content-promocode-input">
          <SemanticInput
            placeholder="PROMO CODE"
            name="promo_code"
            icon={{
              name: 'arrow right',
              circular: false,
              link: true,
              onClick: () => {},
            }}
          />
        </div>
        <div className="payment-card__items-content-promocode-desc">
          <div className="payment-card__items-content-promocode-desc-label">
            Discount:
          </div>
          <div className="payment-card__items-content-promocode-desc-value">
            $0
          </div>
        </div>
      </div>
      <div className="payment-card__items-content-total">
        <div className="payment-card__items-content-total-label">
          Total Price:
        </div>
        <div className="payment-card__items-content-total-value">
          ${accounting.format(projectResume.finalPrice)}
        </div>
      </div>
    </div>
  </div>
);

ProjectSummary.propTypes = {
  projectResume: PropTypes.shape({
    type: PropTypes.string,
    basic_requirements: PropTypes.string,
    duration: PropTypes.string,
    series: PropTypes.string,
    format: PropTypes.string,
    finalPrice: PropTypes.number,
  }),
};

export default ProjectSummary;



// WEBPACK FOOTER //
// ./src/components/PaymentForm/ProjectSummary/ProjectSummary.js